import { Outlet } from "react-router";

const Ota = () => {
	return <Outlet />;
};

export default Ota;
